<template>
  <div v-loading="Loading" class="detail-editor">
    <div class="detail-editor__intro">
      这里维护应用模板在后台和前台展示中都会用到的关键信息。除了名称、Logo 和简介，也可以在这里补充分类、标签与展示文档。
    </div>
    <el-form ref="form" :rules="rules" :model="appDetail" label-width="96px">
      <div class="detail-editor__section">
        <div class="detail-editor__section-title">基础资料</div>
        <el-form-item prop="name" label="应用名称">
          <el-input v-model="appDetail.name" style="width: 360px"></el-input>
        </el-form-item>
        <el-form-item label="应用分类">
          <el-select
            v-model="appDetail.appClassificationID"
            style="width: 360px"
            placeholder="选择应用分类"
            clearable
          >
            <template v-for="item in classes">
              <el-option
                v-if="item.parentAppClassificationID"
                :key="item.appClassificationID"
                :label="item.appClassificationName"
                :value="item.appClassificationID"
              ></el-option>
            </template>
          </el-select>
          <span class="detail-editor__hint">
            为了适应前台展示，应用通常归属到二级分类。
          </span>
        </el-form-item>
        <el-form-item label="所属组织">
          <el-select
            v-model="appDetail.orgID"
            style="width: 360px"
            placeholder="请选择所属组织"
            clearable
          >
            <el-option
              v-for="item in myorgs"
              :key="item.orgID"
              :label="item.name"
              :value="item.orgID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="appLevel" label="应用级别">
          <el-select
            v-model="appDetail.appLevel"
            style="width: 360px"
            placeholder="请选择应用级别"
          >
            <el-option label="企业" value="enterprise"></el-option>
            <el-option label="免费" value="free"></el-option>
          </el-select>
          <span class="detail-editor__hint">
            默认新增应用为企业级，历史应用也会自动补齐为企业级。
          </span>
        </el-form-item>
        <el-form-item prop="tags" label="标签">
          <el-select
            v-model="appDetail.tags"
            multiple
            filterable
            allow-create
            default-first-option
            style="width: 360px"
            placeholder="请输入或选择应用标签"
          >
            <el-option
              v-for="item in existTags"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="recommend" label="推荐置顶">
          <el-switch
            v-model="appDetail.recommend"
            :active-value="1"
            :inactive-value="0"
            active-color="#13ce66"
            inactive-color="#e3e3e3"
          ></el-switch>
        </el-form-item>
        <el-row>
          <el-col :span="8" class="appsFrom">
            <el-form-item
              label="应用Logo"
              ref="uploadpic"
              class="el-form-item-cen"
              prop="logo"
            >
              <el-upload
                class="avatar-uploader"
                :action="uploadConfig.api"
                :with-credentials="true"
                :headers="uploadConfig.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-error="handleAvatarError"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="appDetail.logo" :src="appDetail.logo" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <i
                  v-if="appDetail.logo"
                  class="el-icon-delete"
                  @click.stop="() => handleRemove()"
                ></i>
              </el-upload>
              <span class="detail-editor__hint">
                建议上传 100*100 比例的 Logo
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="desc" label="应用简介">
          <el-input
            type="textarea"
            v-model="appDetail.desc"
            :rows="3"
            style="width: 360px"
          ></el-input>
        </el-form-item>
      </div>

      <div class="detail-editor__section">
        <div class="detail-editor__section-title">展示内容</div>
        <el-form-item label="应用介绍">
          <MdEditor
            v-if="appDetail.initSuccess"
            :content.sync="appDetail.introduction"
          ></MdEditor>
        </el-form-item>
        <el-form-item label="安装使用">
          <MdEditor
            v-if="appDetail.initSuccess"
            :content.sync="appDetail.installDoc"
          ></MdEditor>
        </el-form-item>
        <el-form-item label="产品截图">
          <MdEditor
            v-if="appDetail.initSuccess"
            :content.sync="appDetail.useDoc"
          ></MdEditor>
        </el-form-item>
      </div>
    </el-form>
    <div class="detail-editor__footer">
      <el-button
        class="save_btn"
        type="primary"
        @click="onSubmit"
        :loading="commitLoading"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { updateApp } from '@/api/app';
import { getStoreAvailableTags } from '@/api/appStore';
import { getToken } from '@/utils/auth';
import { errorHandle } from '../../../../utils/error';
export default {
  name: 'BasicInfo',
  props: {
    appDetail: {
      type: Object
    },
    marketID: {
      type: String
    },
    Loading: Boolean,
    appType: String
  },
  data() {
    const baseDomain =
      process.env.BASE_API === '/'
        ? window.location.origin
        : process.env.BASE_API;
    const isChinese = (text) => {
      return /^[\u4e00-\u9fa5]+$/i.test(text);
    };
    const tagValidate = (rule, value, callback) => {
      const tags = Array.isArray(value) ? value : [];

      for (const tag of tags) {
        if (!tag || tag.length < 2) {
          callback('每个标签至少两个字符');
          return;
        }
        if (isChinese(tag) && tag.length > 5) {
          callback('中文标签字数应处于2-5个之间');
          return;
        }
        if (/^\d+$/.test(tag)) {
          callback('标签不能为纯数字组成');
          return;
        }
      }

      callback();
    };
    return {
      classes: [],
      commitLoading: false,
      existTags: [],
      uploadConfig: {
        api: `${baseDomain}/app-server/uploads/picture`,
        headers: {
          Authorization: getToken()
        }
      },
      rules: {
        name: [
          { required: true, message: '应用名称不能为空', trigger: 'blur' },
          { min: 2, message: '至少两个字符', trigger: 'blur' },
          { max: 48, message: '应用名称建议不超过48个字符', trigger: 'blur' }
        ],
        appLevel: [
          { required: true, message: '请选择应用级别', trigger: 'change' }
        ],
        desc: [
          { required: true, message: '应用简介不能为空', trigger: 'blur' },
          { min: 10, message: '至少10个字符', trigger: 'blur' }
        ],
        tags: [{ validator: tagValidate, trigger: 'change' }]
      }
    };
  },
  created() {
    this.fetchStoreAppClassList();
    this.fetchStoreAppTags();
    this.fetchUserOrgs();
  },
  computed: {
    myorgs() {
      return this.$store.state.user.userOrgs;
    }
  },
  watch: {
    'appDetail.tags': {
      handler(value) {
        if (typeof value === 'string') {
          this.appDetail.tags = value
            ? value
                .split(',')
                .map((item) => item.trim())
                .filter(Boolean)
            : [];
          return;
        }

        if (!Array.isArray(value)) {
          this.appDetail.tags = [];
        }
      },
      immediate: true
    },
    'appDetail.recommend': {
      handler(value) {
        if (value === true || value === '1') {
          this.appDetail.recommend = 1;
          return;
        }

        if (value === false || value === '0' || value == null) {
          this.appDetail.recommend = 0;
        }
      },
      immediate: true
    },
    'appDetail.appLevel': {
      handler(value) {
        if (value !== 'enterprise' && value !== 'free') {
          this.appDetail.appLevel = 'enterprise';
        }
      },
      immediate: true
    }
  },
  methods: {
    fetchStoreAppClassList() {
      this.$store
        .dispatch('GetStoreAppClassificationList', {
          marketID: this.marketID,
          disableTree: true
        })
        .then((res) => {
          this.classes = Array.isArray(res)
            ? res
            : Array.isArray(res && res.list)
              ? res.list
              : [];
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    fetchStoreAppTags() {
      getStoreAvailableTags({
        marketID: this.marketID,
        size: -1
      })
        .then((res) => {
          this.existTags = res && res.tags
            ? res.tags.map((item) => item.name)
            : [];
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    fetchUserOrgs() {
      if (this.myorgs && this.myorgs.length) {
        return;
      }

      this.$store.dispatch('GetUserOrgList').catch((err) => {
        errorHandle(err);
      });
    },
    handleAvatarSuccess(res, file) {
      this.appDetail.logo = res.FileURL;
    },
    handleAvatarError(re) {
      if (re.code == 10024) {
        this.$message.warning(
          '上传图片类型不支持，请上传以.png .jpg .jpeg 结尾的图片'
        );
        return;
      }
      this.$message.warning('上传失败!');
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.warning('上传Logo图片只能是JPG、PNG格式!');
      }
      if (!isLt2M) {
        this.$message.warning('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || isPng) && isLt2M;
    },
    handleRemove() {
      this.$confirm('是否删除logo', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.appDetail.logo = '';
      });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // if (this.appDetail.introduction == '<p><br></p>') {
          //   this.$message({
          //     message: '应用介绍不能为空！',
          //     type: 'warning'
          //   });
          //   return;
          // }
          this.commitLoading = true;
          this.$confirm('是否提交数据', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              const payload = Object.assign({}, this.appDetail, {
                tags: Array.isArray(this.appDetail.tags)
                  ? this.appDetail.tags
                  : []
              });

              updateApp(payload)
                .then((res) => {
                  this.$message.success('应用信息更新成功');
                  this.commitLoading = false;
                })
                .catch((err) => {
                  errorHandle(err);
                  this.commitLoading = false;
                });
            })
            .catch(() => {
              this.commitLoading = false;
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import 'src/styles/detail-workspace.scss';

.editorStyle {
  ::v-deep .w-e-text-container > .w-e-scroll > div ol li {
    list-style: auto;
  }

  ::v-deep .w-e-text-container > .w-e-scroll > div ul li {
    list-style: disc;
  }

  ::v-deep .w-e-text-placeholder {
    top: 7px;
  }
}

.barStyle {
  ::v-deep .w-e-bar-item {
    padding: 2.5px;
  }

  ::v-deep .w-e-bar-item > button > .title {
    border-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/storeManage/appManage/components/basicInfo.vue